<button [type]="btype" mdbBtn mdbWavesEffect [size]="size" (click)="onClick($event);"
        [ngClass]="{'disabled-style':  disabled,
            'default-color':   color=='default',
            'primary-color':   color=='primary',
            'secondary-color': color=='secondary',
            'success-color':   color=='success',
            'danger-color':    color=='danger',
            'warning-color':   color=='warning',
            'info-color':      color=='info',
            'light-color':     color=='light',
            'dark-color':      color=='dark',
            'link-color':      color=='link',
            'green-color':     color=='green',
            'orange-color':    color=='orange',
            'lightgrey-color': color=='lightgrey'}">
  <ng-content></ng-content>
</button>
